var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-head"},[_c('div',{staticClass:"ph-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.label)?_c('div',{staticClass:"ph-label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }